import { render, staticRenderFns } from "./PassengersBookedToday.vue?vue&type=template&id=2754a5cb"
import script from "./PassengersBookedToday.vue?vue&type=script&lang=js"
export * from "./PassengersBookedToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports